(function () {
  'use strict';

  var DH_SCRIPT_URL     = 'https://cdn.dashhudson.com/web/js/product-carousel-embed.js';
  var MOBILE_BREAKPOINT = 750;

  /**
   * Manages a single Dash Hudson UGC carousel embed.
   * Config is read from data attributes set by the Liquid section so merchants
   * can update IDs/sizes directly in the theme editor without touching JS.
   */
  function DashHudsonGallery(el) {
    this.el          = el;
    this.galleryEl   = el.querySelector('[data-dh-gallery]');
    this.script      = null;
    this.currentView = null;

    // Pull config from data attributes (set in the section Liquid).
    this.config = {
      id:            el.dataset.dhId            || '',
      boardId:       el.dataset.dhBoardId       || '',
      rowSize:       el.dataset.dhRowSize       || '6',
      gapSize:       el.dataset.dhGapSize       || '2',
      mobileRowSize: el.dataset.dhMobileRowSize || '3',
      mobileGapSize: el.dataset.dhMobileGapSize || '2',
    };

    this._onResize = this._handleResponsive.bind(this);
    this._init();
  }

  // Lazy-load the Dash Hudson script once the section scrolls into view.
  DashHudsonGallery.prototype._init = function () {
    if (!this.galleryEl || !this.config.id || !this.config.boardId) return;

    if ('IntersectionObserver' in window) {
      var self     = this;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            self._loadScript();
          }
        });
      }, { rootMargin: '200px 0px' });
      observer.observe(this.el);
    } else {
      this._loadScript();
    }
  };

  // Inject the Dash Hudson <script> into the gallery container.
  DashHudsonGallery.prototype._loadScript = function () {
    var script   = document.createElement('script');
    script.type  = 'text/javascript';
    script.src   = DH_SCRIPT_URL;
    script.async = true;
    script.setAttribute('data-name',                 'dhproduct-carousel');
    script.setAttribute('data-id',                  this.config.id);
    script.setAttribute('data-board-id',            this.config.boardId);
    script.setAttribute('data-row-size',            this.config.rowSize);
    script.setAttribute('data-gap-size',            this.config.gapSize);
    script.setAttribute('data-mobile-row-size',     this.config.mobileRowSize);
    script.setAttribute('data-mobile-gap-size',     this.config.mobileGapSize);
    script.setAttribute('data-skip-screen-readers', 'true');
    script.setAttribute('show-header',              '0');

    this.script = script;
    this.galleryEl.appendChild(script);

    this._watchEmpty();
    this._handleResponsive();
    window.addEventListener('resize', this._onResize);
  };

  // Watch for the Dash Hudson empty state: when it injects a child with class
  // "empty", hide the whole section so it doesn't leave a blank gap on the page.
  DashHudsonGallery.prototype._watchEmpty = function () {
    var self    = this;
    var section = this.el;
    var target  = this.galleryEl;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.classList.contains('empty')) {
            section.classList.add('hidden');
            observer.disconnect();
          }
        });
      });
    });

    observer.observe(target, { childList: true, subtree: true });
  };

  // Toggle data-high-res based on viewport width (mirrors old _.mq logic).
  DashHudsonGallery.prototype._handleResponsive = function () {
    if (!this.script) return;
    var isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    if (isMobile && this.currentView !== 'mobile') {
      this.script.setAttribute('data-high-res', '0');
      this.currentView = 'mobile';
    } else if (!isMobile && this.currentView !== 'desktop') {
      this.script.removeAttribute('data-high-res');
      this.currentView = 'desktop';
    }
  };

  // Initialize all Dash Hudson sections on the page.
  function init() {
    document.querySelectorAll('[data-dash-hudson]').forEach(function (el) {
      if (!el._dhGallery) {
        el._dhGallery = new DashHudsonGallery(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
